"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTeamInfo = exports.getMultiple = exports.getAll = exports.updateEmployee = exports.search = exports.typeaheadSearch = exports.getByPosition = exports.updatePosition = exports.getPositions = exports.updateSettings = exports.updateProfile = exports.update = exports.create = exports.get = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var join_1 = tslib_1.__importDefault(require("lodash/join"));
var query_string_1 = tslib_1.__importDefault(require("query-string"));
var base = '/api/employee';
function get(id) {
    return api_1.default.get("".concat(base, "/").concat(id)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.get = get;
function create(employeeData) {
    return api_1.default.post(base, employeeData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.create = create;
function update(employeeId, employeeData) {
    return api_1.default.put("".concat(base, "/").concat(employeeId), employeeData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.update = update;
function updateProfile(employeeData) {
    return api_1.default.put("".concat(base, "/profile"), employeeData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.updateProfile = updateProfile;
function updateSettings(employeeId, settings) {
    return api_1.default.put("".concat(base, "/settings"), settings).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.updateSettings = updateSettings;
function getPositions(employeeId) {
    return api_1.default.get("".concat(base, "/").concat(employeeId, "/positions")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getPositions = getPositions;
function updatePosition(positionData) {
    return api_1.default.put("".concat(base, "/position"), positionData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.updatePosition = updatePosition;
function getByPosition(positions) {
    var query = (0, join_1.default)(positions, '&employeePosition=');
    return api_1.default.get("".concat(base, "/by-position?employeePosition=").concat(query)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getByPosition = getByPosition;
function typeaheadSearch(positions, name) {
    var nameQuery = name ? "q=".concat(encodeURIComponent(name)) : '';
    var positionsQuery = positions.length ? "positions=".concat(positions.join('&positions=')) : '';
    return api_1.default
        .get("".concat(base, "/typeahead?").concat(positionsQuery, "&").concat(nameQuery))
        .then(api_1.extractData)
        .then(function (data) {
        return data.map(function (item) { return ({
            id: item.id,
            fullName: item.name,
            email: item.email,
        }); });
    })
        .catch(api_1.errorHandler);
}
exports.typeaheadSearch = typeaheadSearch;
function search(query) {
    var queryParams = query_string_1.default.stringify(query);
    return api_1.default.get("".concat(base, "/search?").concat(queryParams)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.search = search;
function updateEmployee(employeeData) {
    return api_1.default.put("".concat(base, "/").concat(employeeData.id), employeeData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.updateEmployee = updateEmployee;
function getAll() {
    return api_1.default.get("".concat(base, "?select=true")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getAll = getAll;
function getMultiple(ids) {
    return api_1.default.post("".concat(base, "/multiple"), { ids: ids }).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getMultiple = getMultiple;
function getTeamInfo(ids) {
    return api_1.default.post("".concat(base, "/team-info"), ids).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getTeamInfo = getTeamInfo;
var api = {
    get: get,
    create: create,
    update: update,
    updateSettings: updateSettings,
    getByPosition: getByPosition,
    typeaheadSearch: typeaheadSearch,
    search: search,
    updateEmployee: updateEmployee,
    getAll: getAll,
    getMultiple: getMultiple,
    getTeamInfo: getTeamInfo,
    getPositions: getPositions,
    updatePosition: updatePosition,
    updateProfile: updateProfile,
};
exports.default = api;
